/**
 * Matomo snippet (spec §2.3), externalized for CSP — script-src allows no
 * unsafe-inline. Cookie-consent mode: tracking requests are always sent
 * (cookieless without consent), cookies only after the Klaro callback grants
 * cookie consent. Tracker URL and site ID arrive via data attributes from
 * the render-time guard in views/frontend/main.php.
 *
 * Loaded as a classic sync script at the position of the former inline
 * snippet (end of body, before the main.js module): this keeps
 * requireCookieConsent ahead of any event push in the _paq queue, so the
 * cookie gate holds.
 */

const snippet = document.currentScript;
const trackerUrl = snippet.dataset.trackerUrl;
const siteId = snippet.dataset.siteId;

window._paq = window._paq || [];
/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
// Cookie-consent mode (not tracking-consent): tracking requests are always
// sent, but no cookies are written until the Klaro callback grants cookie
// consent. Visitors who decline are still measured — cookieless.
window._paq.push(["requireCookieConsent"]);
window._paq.push(["trackPageView"]);
window._paq.push(["enableLinkTracking"]);

(function () {
	window._paq.push(["setTrackerUrl", trackerUrl + "matomo.php"]);
	window._paq.push(["setSiteId", siteId]);
	const d = document,
		g = d.createElement("script"),
		s = d.getElementsByTagName("script")[0];
	g.async = true;
	g.src = trackerUrl + "matomo.js";
	s.parentNode.insertBefore(g, s);
})();
